export abstract class Base {
    fromObject?(obj: any) {
        for (var propName in obj) {
            const prop = `${propName.charAt(0).toUpperCase()}${propName.slice(1)}`;
            this[prop] = obj[propName];
        }
    }

    fromJson?(json: string) {
        const jsonObj = JSON.parse(json);
        for (var propName in jsonObj) {
            this[propName] = jsonObj[propName];
        }
    }
}